import Vue from 'vue'
import {
  Container,
  Form,
  FormItem,
  Input,
  Button,
  Header,
  Aside,
  Main,
  Row,
  Col,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Tag,
  Message,
  Card,
  Select,
  Option,
  DatePicker,
  Alert,
  Table,
  TableColumn,
  Switch,
  Pagination,
  Dialog,
  Radio,
  RadioGroup,
  RadioButton,
  Avatar,
  Upload,
  MessageBox,
  Tabs,
  TabPane,
  Cascader,
  TimePicker,
  Divider,
  Scrollbar,
  Breadcrumb,
  BreadcrumbItem,
  Checkbox,
  CheckboxGroup,
  Popover,
  DropdownItem,
  DropdownMenu,
  Dropdown,
  Image,
  TimeSelect,
  Step,
  Steps
} from 'element-ui'

Vue.use(Container)
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Tag)
Vue.use(Card)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Alert)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Avatar)
Vue.use(Upload)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Cascader)
Vue.use(TimePicker)
Vue.use(Divider)
Vue.use(Scrollbar)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Dropdown)
Vue.use(Image)
Vue.use(TimeSelect)
Vue.use(Steps)
Vue.use(Step)


Vue.prototype.$msg = Message
Vue.prototype.$MessageBox = MessageBox
